import { PaymentButtonType } from "./types";

export const LOCALE_EN = "en";
export const LOCALE_DE = "de";
export const LOCALE_JA = "ja";
export const LOCALE_KO = "ko";
export const LOCALE_ZH = "zh";
export const LOCALE_ES = "es";
export const LOCALE_FR = "fr";
export const LOCALE_PT = "pt";
export const LOCALE_NL = "nl";
export const LOCALE_EN_LABEL = "English";
export const LOCALE_DE_LABEL = "German (Deutsch)";
export const LOCALE_JA_LABEL = "Japanese (日本語)";
export const LOCALE_KO_LABEL = "Korean (한국어)";
export const LOCALE_ZH_LABEL = "Mandarin (中文)";
export const LOCALE_ES_LABEL = "Spanish (Español)";
export const LOCALE_FR_LABEL = "French (Français)";
export const LOCALE_PT_LABEL = "Portuguese (Português)";
export const LOCALE_NL_LABEL = "Dutch (Nederlands)";

export const BUILD_ENV = {
  production: "production",
  staging: "staging",
  testing: "testing",
  development: "development",
} as const;

export type BUILD_ENV_TYPE = (typeof BUILD_ENV)[keyof typeof BUILD_ENV];

export const CHECKOUT_URLS = {
  [BUILD_ENV.production]: "https://checkout.web3auth.io",
  [BUILD_ENV.staging]: "https://staging-checkout.web3auth.io",
  [BUILD_ENV.testing]: "https://develop-checkout.web3auth.io",
  [BUILD_ENV.development]: "https://develop-checkout.web3auth.io",
};

export const LOCALES = [
  {
    name: LOCALE_EN_LABEL,
    value: LOCALE_EN,
  },
  {
    name: LOCALE_DE_LABEL,
    value: LOCALE_DE,
  },
  {
    name: LOCALE_JA_LABEL,
    value: LOCALE_JA,
  },
  {
    name: LOCALE_KO_LABEL,
    value: LOCALE_KO,
  },
  {
    name: LOCALE_ZH_LABEL,
    value: LOCALE_ZH,
  },
  {
    name: LOCALE_ES_LABEL,
    value: LOCALE_ES,
  },
  {
    name: LOCALE_FR_LABEL,
    value: LOCALE_FR,
  },
  {
    name: LOCALE_PT_LABEL,
    value: LOCALE_PT,
  },
  {
    name: LOCALE_NL_LABEL,
    value: LOCALE_NL,
  },
];

export const ROUTES = {
  CHECKOUT: "checkout",
};

export const PAYMENT_TYPES = {
  CREDIT_CARD: "credit_card",
  APPLE_PAY: "apple_pay",
  GOOGLE_PAY: "google_pay",
};

export const PAYMENT_BUTTONS: PaymentButtonType[] = [
  { name: "Pay with Credit Card", value: PAYMENT_TYPES.CREDIT_CARD, icon: "credit-card-solid-icon" },
];

export const SESSION_STORAGE_KEY = {
  ORDER_TRACKING_ID: "nft_checkout_order_id",
};

export const STRIPE_PAYMENT_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
};

export type STRIPE_PAYMENT_STATUS_TYPE = (typeof STRIPE_PAYMENT_STATUS)[keyof typeof STRIPE_PAYMENT_STATUS];

export const NFT_CHECKOUT_STEPS = {
  ORDER_FORM: "order_form",
  PAYMENT_FORM: "payment_form",
  PAYMENT_STATUS: "payment_status",
  PAYMENT_PROCESSING: "payment_processing",
  CHECKOUT_RESULT: "checkout_result",
  CHECKOUT_STATUS: "checkout_status",
};

export const CONTRACT_TYPE = {
  ERC721: "erc721",
  ERC1155: "erc1155",
};
